import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { pathFor } from "@/i18n/translations";
import { IMAGES } from "@/config/images";
import { Reveal } from "@/components/Reveal";
import { PageHero, AccentButton, OutlineButton, Overline } from "@/components/ui-kit";

export default function About() {
  const { lang, t } = useLang();
  const a = t.about;
  return (
    <div>
      <PageHero image={IMAGES.workshop} alt={t.alts.aboutHero} overline={t.nav.about} titleLines={[a.heroTitle]} subtitle={a.heroSub} />

      {/* Story two-column */}
      <section className="py-24 md:py-32 bg-[var(--bg-primary)]">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="relative overflow-hidden aspect-[4/5]">
                <img src={IMAGES.garage} alt={t.alts.aboutStory} loading="lazy" className="w-full h-full object-cover grayscale hover:scale-105 transition-transform duration-700" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <Overline>{a.storyTitle}</Overline>
              <p className="mt-6 text-lg text-zinc-300 leading-relaxed">{a.story}</p>
              <p className="mt-5 text-zinc-400 leading-relaxed">{a.story2}</p>
              <ul className="mt-8 grid grid-cols-2 gap-y-3 gap-x-6">
                {a.values.map((v, i) => (
                  <li key={i} className="flex items-center gap-2.5 text-sm text-zinc-300">
                    <Check size={15} style={{ color: "var(--accent)" }} /> {v}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Why choose us */}
      <section className="py-24 md:py-32 bg-[var(--bg-secondary)]">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8">
          <Reveal>
            <h2 className="font-display font-semibold text-white text-4xl sm:text-5xl">{a.whyTitle}</h2>
          </Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {t.why.items.map((w, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className="bg-[var(--bg-primary)] p-8 md:p-12 h-full flex gap-6">
                  <span className="font-display text-4xl font-bold" style={{ color: "var(--accent)" }}>{w.n}</span>
                  <div>
                    <h3 className="font-display text-2xl font-medium text-white">{w.name}</h3>
                    <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{w.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[var(--bg-primary)]">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <h2 className="font-display font-semibold text-white text-3xl sm:text-4xl max-w-xl">{t.finalCta.title}</h2>
          <div className="flex flex-col sm:flex-row gap-4">
            <AccentButton to={pathFor(lang, "contact")} testid="about-book-btn">{t.cta.book}</AccentButton>
            <OutlineButton to={pathFor(lang, "contact")} testid="about-quote-btn">{t.cta.quote}</OutlineButton>
          </div>
        </div>
      </section>
    </div>
  );
}
